import Section_Desktop from "./Section_Desktop";
import { useEffect, useState, Suspense } from "react";
import ErrorBoundary_component from "../../ErrorHandling/ErrorBoundary_component";

function SideBar_2({ menuPages = [], menuSections = [] }) {
const [expandedSection, setExpandedSection] = useState(null);

  useEffect(() => {
    Number(sessionStorage.getItem("sidebarStatus")) === 0 ? resizeSideBar() : null;
  }, []);

  function resizeSideBar() {
    var x = document.getElementById("test-sidebar");
    var y = document.getElementById("test-collapser");
    var sideContainer = document.getElementById("sidemenu-operation");
    var btn = document.getElementById("menu-extend-btn");
    var line = document.getElementById("collapser-line");
    var pageContent = document.getElementById("page-container");
    
    if (btn.classList.contains("menu-active-btn")) {
      x.style.display = "none";
      y.style.left = "30px";
      sideContainer.style.minWidth = "60px";
      btn.innerHTML = "keyboard_arrow_right";
      btn.classList.add("menu-hidden-btn");
      btn.classList.remove("menu-active-btn");
      line.style.width = "3px";
      pageContent.style.setProperty("min-width", "calc(100vw - 125px)");
      pageContent.style.setProperty("left", "-15px");
      sessionStorage.setItem("sidebarStatus", 0);
      toggleGstAlert('show');
    } else {
      x.style.display = "block";
      y.style.left = "270.5px";
      sideContainer.style.minWidth = "276px";
      btn.innerHTML = "keyboard_arrow_left";
      btn.classList.add("menu-active-btn");
      btn.classList.remove("menu-hidden-btn");
      line.style.width = "3";
      pageContent.style.setProperty("width", "calc(100vw - 350px)");
      pageContent.style.setProperty("min-width", "calc(100vw - 350px)");
      pageContent.style.setProperty("left", "0px");
      sessionStorage.setItem("sidebarStatus", 1);
      toggleGstAlert('hide');
    }
  }
  function toggleGstAlert(status) {
    let alertOnPage = document.querySelector('.alert-inline-filter-right');
    if (alertOnPage !== null) {
      if (status === 'show') {
        alertOnPage.classList.contains('hideAlert') ? alertOnPage.classList.remove('hideAlert') : null;
      } else {
        alertOnPage.classList.add('hideAlert');
      }
    }
  }

  return (
    <div id="sidemenu-operation" className="print-hidden">
      <div id="test-sidebar">
        <div id="test-scroll">
         <ErrorBoundary_component
        fallback={
          <div className="err_default">
            <p><b>Error: </b><i>Section <span className={"errorCode"}>(100)</span></i></p>
          </div>
        }
      >
        {menuSections
          .filter((y) => y.Pages)
          .map((x) => (
            <div key={x.id}>
            <Suspense fallback={<h1>Loading</h1>}>
             <Section_Desktop
              key={x.name}
              sectionTitle={x.name}
              pages={menuPages.filter((z) => 
                z.section === x.name && !z.urlPath.includes(':')
              )}
              expandedSection={expandedSection}
          onSectionToggle={setExpandedSection}
          allSectionNames={menuSections.map(s => s.name)}
            />
            </Suspense>
            </div>
          ))}
      </ErrorBoundary_component>
        </div>
      </div>
      <div id="test-collapser">
        <span
          id="menu-extend-btn"
          onClick={resizeSideBar}
          className="material-symbols-outlined menu-active-btn"
        >
          keyboard_arrow_left
        </span>
        <hr id="collapser-line" className="line"></hr>
      </div>
    </div>
  );
}

export default SideBar_2;